import { get, post, put, destroy } from './Base';
// import { postPublic } from './BasePublic';

export const AuthService = {
    login: async (params) => await post('/Auth', params),
    logout: async (token) => await post('/Auth/CerrarSesion', token),
    changeOwnPassword: async (params) =>
        await post('/Auth/CambiarClave', params),
};

export const ConfirmEmailService = {
    send: async (params) => await post('/Auth/ConfirmaCorreo', params),
};

export const ResendEmailService = {
    send: async (params) => await post('/Auth/ReenviaCorreo', params),
};

export const ChangePasswordStep1Service = {
    send: async (params) => await post('/Auth/ResetClavePasoUno', params),
};

export const ChangePasswordStep2Service = {
    send: async (params) => await post('/Auth/ResetClavePasoDos', params),
};

export const RecoverUserService = {
    send: async (params) => await post('/Auth/RecuperarUsuario', params),
};

export const SettingsService = {
    all: async (params) => await post('/Ajustes/GetAjustes', params),
    update: async (params) => await post('/Ajustes/PutAjustes', params),
};

export const LogService = {
    byObject: async (params) => await post('/Log/BuscarQuery', params),
    totalRecords: async (params) => await post('/Log/BuscarCount', params),
};

export const ConstantsService = {
    userTypes: async () => await get('/Constantes/GetUsuarioTipos'),
    documentTypes: async () => await get('/Constantes/GetDoc_id_tipo'),
    habilitationTypes: async () =>
        await get('/Constantes/GetHabilitacion_tipo'),
    guiaStateTypes: async () => await get('/Constantes/GetEstadoGuia'),
    accionTypes: async () => await get('/Constantes/GetAcciones'),
    objectTypes: async () => await get('/Constantes/GetObjetos'),
    letterTypes: async () => await get('/Constantes/GetLetrasContador'),
    departments: async () => await get('/Constantes/GetDepartamentos'),
    destinos: async () => await get('/Constantes/GetDestinoGuia'),
};

export const BodegasService = {
    all: async (params) => await post('/Bodegas/GetBodegas', params),
};

export const DeclaracionesService = {
    search: async (params) => await post('/Declaraciones/BuscarQuery', params),
    totalRecords: async (params) =>
        await post('/Declaraciones/BuscarCount', params),
};

export const GuiasService = {
    all: async (params) => await post('/Guias/GetGuiasLista', params),
    single: async (params) => await post('/Guias/GetGuia', params),
    create: async (params) => await post('/Guias/NuevaGuia', params),
    update: async (params) => await post('/Guias/PutGuia', params),
    delete: async (params) => await post('/Guias/EliminarGuia', params),
    search: async (params) => await post('/Guias/BuscarQuery', params),
    totalRecords: async (params) => await post('/Guias/BuscarCount', params),
};

export const DJCPService = {
    all: async (params) => await post('/DJCP/GetDJCPLista', params),
    single: async (params) => await post('/DJCP/GetDJCP', params),
    create: async (params) => await post('/DJCP/NuevaDJCP', params),
    update: async (params) => await post('/DJCP/PutDJCP', params),
    payTimbre: async (params) => await post('/DJCP/SolicitarTimbre', params),
    inhab: async (params) => await post('/DJCP/Inhabilitar', params),
};

export const DJCEService = {
    all: async (params) => await post('/DJCE/GetDJCELista', params),
    allForINAVISigning: async (params) =>
        await post('/DJCE/GetDJCEListaInavi', params),
    single: async (params) => await post('/DJCE/GetDJCE', params),
    create: async (params) => await post('/DJCE/NuevaDJCE', params),
    update: async (params) => await post('/DJCE/PutDJCE', params),
    verificarDJCEs: async (params) => await post('/DJCE/VerificarDJCE', params),
    payTimbre: async (params) => await post('/DJCE/SolicitarTimbre', params),
};

export const UserService = {
    single: async (params) => await post('/User/GetUsuario', params),
    create: async (params) => await post('/User/SignUp', params),
    createINAVI: async (params) =>
        await post('/User/CrearUsuarioInavi', params),
    update: async (params) => await put('/User/Actualizar', params),
    search: async (params) => await post('/User/BuscarQuery', params),
    totalRecords: async (params) => await post('/User/BuscarCount', params),
    getNombreUsuario: async (params) =>
        await post('/User/GetNombreUsuario', params),
    sendComment: async (params) => await post('/User/Comentario', params),
    getHelpText: async (params) => await post('/User/Ayuda', params),
};

export const ManagerService = {
    all: async (params) => await post('/User/EncargadosLista', params),
    create: async (params) => await post('/User/Encargado', params),
    update: async (params) => await put('/User/Actualizar', params),
};

export const UserWaitingHabilitationService = {
    all: async (token) => await post('/User/EnEsperaHabilitacion', token),
};

export const ViniedoService = {
    all: async (params) => await post('/Viniedo/GetViniedosUsuario', params),
    single: async (params) => await post('/Viniedo/GetViniedoUsuario', params),
    arcGisByNumber: async (params) =>
        await post('/Viniedo/GetViniedoArcgis', params),
    grapesVariety: async (params) =>
        await post('/Viniedo/GetVariedadesUva', params),
    search: async (params) => await post('/Viniedo/BuscarQuery', params),
    totalRecords: async (params) => await post('/Viniedo/BuscarCount', params),
    syncArcGis: async (params) =>
        await post('/Viniedo/SincronizarArcgis', params),
};
